import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Transaction from "layouts/dashboard/components/transactions/item";
import moment from "moment";

function TransactionList({ transactions, selectedAccount, openEditModal }) {
  const groupByDate = (transactions) => {
    return transactions.reduce((grouped, transaction) => {
      const date = moment(transaction.date).format("DD MMMM yyyy");
      if (!grouped[date]) {
        grouped[date] = [];
      }
      grouped[date].push(transaction);
      return grouped;
    }, {});
  };

  const groupedTransactions = groupByDate(transactions);

  return (
    <Card xs={12} md={5}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={3} px={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
            Transactions
        </MDTypography>
        <MDBox display="flex" alignItems="flex-start">
          <MDBox color="text" mr={0.5} lineHeight={0}>
            <Icon color="inherit" fontSize="small">date_range</Icon>
          </MDBox>
          <MDTypography variant="button" color="text" fontWeight="regular">
            {moment(transactions[0]?.date).format("MMMM yyyy")}
          </MDTypography>
        </MDBox>
      </MDBox>
      <MDBox pt={3} pb={2} px={2}>
        {Object.keys(groupedTransactions).map((date, index) => (
          <MDBox key={index}>
            <MDBox mb={2}>
              <MDTypography variant="caption" color="text" fontWeight="bold" textTransform="uppercase">
                {date}
              </MDTypography>
            </MDBox>
            <MDBox display="flex" flexDirection="column" p={0} m={0} sx={{ listStyle: "none" }}>
              {groupedTransactions[date].map((transaction) => (
                <Transaction key={transaction.id} transaction={transaction} selectedAccount={selectedAccount} openEditModal={openEditModal} />
              ))}
            </MDBox>
          </MDBox>
        ))}
      </MDBox>
    </Card>
  );
}

TransactionList.propTypes = {
    transactions: PropTypes.array.isRequired,
    openEditModal: PropTypes.func.isRequired,
};

export default TransactionList;
